export default __webpack_public_path__ + "static/Check_green_icon-d8065406190e8e537f62fbcfdd142241.png";